import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './elevated-box.styl'

export default class ElevatedBox extends Component {
  static propTypes = {
    children: PropTypes.any,
    clickable: PropTypes.bool,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    clickable: false
  }

  render() {
    const { clickable, children } = this.props
    const classNames = [styles.wrap]

    clickable && classNames.push(styles.clickable)

    return (
      <div
        className={classNames.join(' ')}
        onClick={this.props.onClick}
      >
        {children}
      </div>
    )
  }
}
